import type { Product, Trait, TraitsForContext } from '../types';

const AUTO_UPGRADE_PRODUCT_TRAIT: Record<Product, string> = {
	jira: 'jsw_ccp_auto_upgraded_trialing_and_predunning_sites',
	'jira-service-management': 'jsm_ccp_auto_upgraded_trialing_and_predunning_sites',
	'jira-product-discovery': 'jpd_ccp_auto_upgraded_trialing_and_predunning_sites',
	confluence: 'confluence_ccp_auto_upgraded_trialing_and_predunning_sites',
};

export const getSiteTraitValues = (traits: Trait[], product: Product): TraitsForContext => {
	if (traits.length === 0) {
		return {
			automationUsage: 0,
			lastAutomationFreeLimitBreachDate: null,
			isAutoUpgraded: false,
		};
	}

	const automationUsageTrait = traits.find(
		(trait) => trait.name === 'growth_automation_limits_current_usage',
	);
	const lastAutomationFreeLimitBreachDateTrait = traits.find(
		(trait) => trait.name === 'growth_automation_limits_usage_latest_breach_date',
	);
	const isAutoUpgradedTrait = traits.find(
		(trait) => trait.name === AUTO_UPGRADE_PRODUCT_TRAIT[product],
	);

	const automationUsage =
		automationUsageTrait &&
		automationUsageTrait.value !== undefined &&
		!isNaN(Number(automationUsageTrait.value))
			? Number(automationUsageTrait.value)
			: 0;

	const lastAutomationFreeLimitBreachDate =
		lastAutomationFreeLimitBreachDateTrait &&
		typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' &&
		!isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value))
			? new Date(lastAutomationFreeLimitBreachDateTrait.value)
			: null;

	const isAutoUpgraded = Boolean(
		isAutoUpgradedTrait &&
			typeof isAutoUpgradedTrait.value === 'boolean' &&
			isAutoUpgradedTrait.value,
	);

	return {
		automationUsage,
		lastAutomationFreeLimitBreachDate,
		isAutoUpgraded,
	};
};
